import React from 'react'

import { Portlet, Col, Row, Button } from '_zari/core'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Fondos Fijos' }, { name: 'Reportes' }]

const ReportePage = () => {
  const [mostrarReporteEntregas, setMostrarReporteEntregas] = React.useState(false)

  return (
    <>
      <Portlet>
        <Portlet.Header title='Fondos Fijos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Button onClick={() => setMostrarReporteEntregas(true)}>Continuar</Button>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarReporteEntregas && (
        <Modals.ReporteEntregasModal
          show={mostrarReporteEntregas}
          handleClose={() => setMostrarReporteEntregas(false)}
        />
      )}
    </>
  )
}

export default React.memo(ReportePage)
